import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-screens',
  templateUrl: './no-screens.component.html',
  styleUrls: ['./no-screens.component.scss'],
})
export class NoScreensComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
